import Frozen from "../Core/Frozen.js";

/**
 * Image formats supported by the browser.
 *
 * @param {object} [options] Object with the following properties:
 * @param {boolean} [options.webp=false] Whether the browser supports WebP images.
 * @param {boolean} [options.basis=false] Whether the browser supports compressed textures required to view KTX2 + Basis Universal images.
 *
 * @private
 */
function SupportedImageFormats(options) {
  var _options$webp, _options$basis;
  options = options !== null && options !== void 0 ? options : Frozen.EMPTY_OBJECT;
  this.webp = (_options$webp = options.webp) !== null && _options$webp !== void 0 ? _options$webp : false;
  this.basis = (_options$basis = options.basis) !== null && _options$basis !== void 0 ? _options$basis : false;
}
export default SupportedImageFormats;